export default __webpack_public_path__ + "static/media/logo8.4f871245.svg";